// src/components/CustomCursor.jsx
import { useEffect } from "react";
import "./CustomCursor.css";

const CustomCursor = () => {
  useEffect(() => {
    const cursor = document.querySelector(".cursor");
    const follower = document.querySelector(".cursor-follower");

    const moveCursor = (e) => {
      const { clientX: x, clientY: y } = e;
      cursor.style.left = x + "px";
      cursor.style.top = y + "px";

      follower.animate(
        [
          { left: follower.style.left, top: follower.style.top },
          { left: x - 12 + "px", top: y - 12 + "px" },
        ],
        {
          duration: 150,
          fill: "forwards",
        }
      );
    };

    document.addEventListener("mousemove", moveCursor);
    return () => document.removeEventListener("mousemove", moveCursor);
  }, []);

  return (
    <>
      <div className="cursor" />
      <div className="cursor-follower" />
    </>
  );
};

export default CustomCursor;
